export default __webpack_public_path__ + "static/media/GROTrackGrey.b1d35901.svg";